<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed()">
    <ifbp-submission-autocomplete-input
      baseFilterItem
      label="Legal entity name"
      [fieldName]="FieldName.AccountName"
      [fc]="form.get('accountName')"
    ></ifbp-submission-autocomplete-input>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select multiple formControlName="brokerStatus" placeholder="Status">
        <mat-option *ngFor="let option of brokerStatusOptions" [value]="option.value">{{ option.name }}</mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('brokerStatus')?.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('brokerStatus').setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <ifbp-submission-autocomplete-input
      baseFilterItem
      label="First agent"
      [fieldName]="FieldName.FirstAgent"
      [fc]="form.get('firstAgent')"
    ></ifbp-submission-autocomplete-input>
    <ifbp-submission-autocomplete-input
      baseFilterItem
      label="Assigned agent"
      [fieldName]="FieldName.AssignedAgent"
      [fc]="form.get('assignedAgent')"
    ></ifbp-submission-autocomplete-input>

    <ifc-filter-param-date-range-input
      baseFilterItem
      [fc]="form.get('createdOn')"
      [label]="'Created on'"
      (rangeSelected)="createdOnDateSelected($event)"
    ></ifc-filter-param-date-range-input>
    <ifc-filter-param-date-range-input
      baseFilterItem
      [fc]="form.get('updatedOn')"
      [label]="'Updated on'"
      (rangeSelected)="updatedOnDateSelected($event)"
    ></ifc-filter-param-date-range-input>

    <ng-container *ngIf="form.get('createdOn')?.value === 'custom'">
      <ifc-datepicker
        baseFilterItem
        [fc]="form.get('createdOnFrom')"
        [max]="form.get('createdOnTo')?.value"
        [label]="'Created date from'"
      ></ifc-datepicker>
      <ifc-datepicker
        baseFilterItem
        [fc]="form.get('createdOnTo')"
        [min]="form.get('createdOnFrom')?.value"
        [label]="'Created date to'"
      ></ifc-datepicker>
    </ng-container>

    <ng-container *ngIf="form.get('updatedOn')?.value === 'custom'">
      <ifc-datepicker
        baseFilterItem
        [fc]="form.get('updatedOnFrom')"
        [max]="form.get('updatedOnTo')?.value"
        [label]="'Updated date from'"
      ></ifc-datepicker>
      <ifc-datepicker
        baseFilterItem
        [fc]="form.get('updatedOnTo')"
        [min]="form.get('updatedOnFrom')?.value"
        [label]="'Updated date to'"
      ></ifc-datepicker>
    </ng-container>
  </ifc-base-filter-dialog>
</form>
